import { Directive, TemplateRef } from '@angular/core';

@Directive({ standalone: false, selector: '[appQueryField]' })
export class QueryFieldDirective
{
  constructor(public template: TemplateRef<any>) { }
}
